import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-tracking',
  templateUrl: './task-tracking.component.html',
  styleUrls: ['./task-tracking.component.css']
})
export class TaskTrackingComponent implements OnInit {

  private map!: L.Map;
  usersList: any= []
  cid:any
  date1:any
  date2: any
  filteredData: any = [];
  userID:any = ""
  taskStatus: any = [];

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getUsersWithoutCustomers()
    this.date2 = new Date()
    this.date2.setDate(this.date2.getDate());
    this.date2 = formatDate(this.date2, 'yyyy-MM-dd', 'en-US')
    console.log(new Date(this.date2).getTime())
    this.date1 = new Date()
    this.date1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
  }

  // getUsers(){
  //   this.generic_service.getUsers().subscribe(
  //     (res:any)=>{
  //       this.usersList = res.response;
  //       console.log(this.usersList)
  //     }
  //   )
  // }

  private centroid1: L.LatLngExpression[]= [
    [16.160552,
    81.1058173
  ]
  ];


  private initMap(): void {
    
    this.map = L.map('map', {
      center: this.centroid1[0],
      zoom: 16
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    // create 5 random jitteries and add them to map
    for(let i = 0; i < this.centroid1.length; i++){

     let loc = L.marker(this.centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup('a marker location').openPopup()
     loc.addTo(this.map)
    }

    
    tiles.addTo(this.map);
    console.log(this.map);


  }

  defaultIcon = L.icon({
    iconUrl: 'assets/4899329.png', // your path may vary ...
    iconSize: [80, 80],
    iconAnchor: [2, 2],
    popupAnchor: [40, -4]
  });


  filterByTicketStatusAndBetweenDates(){
    let startDate = new Date(this.date1).getTime()
    let endDate = new Date(this.date2).getTime()
    this.generic_service.filterByTaskAssignedToBetweenDates(this.userID,startDate,endDate).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.filteredData = response.response
        this.taskStatus = []
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  ngOnDestroy(){
    console.log("ngOnDestroy")
    this.map.remove();
  }

  getSingleTask(id:any){
    console.log(id)
    this.generic_service.getSingleTask(id).subscribe(
      (res:any)=>{
        this.taskStatus = [];
        console.log(res);
        this.taskStatus = res.response.status;
        // this.taskStatus.push(res.response.status);
        console.log(this.taskStatus)
      }
    )
  }

  Reloadpage(){
    return window.location.reload()
  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
    this.initMap()

      }
    )

  }

}